// configFetcher.ts
import { getStableWidgetLocale } from "../utils/locale";
export async function fetchPopupConfig(endpoint, promptRequest) {
    try {
        const client = window.shineSettings.client;
        const chatbot = window.shineSettings.chatbot;
        const url = new URL(`${endpoint}Conversation/Widget`);
        url.searchParams.set('client', client);
        url.searchParams.set('chatbot', chatbot);
        const locale = getStableWidgetLocale();
        if (locale) {
            url.searchParams.set('locale', locale);
        }
        if (promptRequest?.url) {
            url.searchParams.set('url', promptRequest.url);
        }
        if (promptRequest?.fingerprint) {
            url.searchParams.set('fingerprint', promptRequest.fingerprint);
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });
        if (!response.ok) {
            throw new Error(`Error fetching config: ${response.statusText}`);
        }
        // Expected response structure:
        // { widget: PopupConfig, inline: PopupConfig | PopupConfig[] }
        const config = await response.json();
        if (config?.widgetSession) {
            config.widgetSessionClient = client;
            config.widgetSessionChatbot = chatbot;
        }
        return config;
    }
    catch (error) {
        console.error('Failed to fetch popup configuration:', error);
        throw error;
    }
}
